import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import validationConfig from './validationConfig'
import CustomCollapse from '../../../../common/CustomCollapse'
import { CheckboxField, MultiSelectField, SelectField } from '../../../../common/FormFields'
import CheckIcon from '../../../../../assets/icons/check-icon.svg'
import ErrorIcon from '../../../../../assets/icons/exclamation-icon.svg'
import FormValidators from '../../../../../helpers/FormValidators'
import { getAllContractTypes, getAllProductStatuses, getAllProductTypes } from '../../../../../redux/actions/lookupData'

const PlatformSettingsForm = ({ platformId, platformName, formState, disabled }) => {
  // ===== Form state =====
  const { formData, formErrors, onFormDataChanged, validateFormField } = formState

  // ===== Redux state =====
  const dispatch = useDispatch()
  const allProductStatuses = useSelector(({ lookupData }) => lookupData?.allProductStatuses) || []
  const allProductTypes = useSelector(({ lookupData }) => lookupData?.allProductTypes) || []
  const allContractTypes = useSelector(({ lookupData }) => lookupData?.allContractTypes) || []

  // ==== Side effects =====
  useEffect(() => {
    dispatch(getAllProductStatuses())
    dispatch(getAllProductTypes())
    dispatch(getAllContractTypes(platformId)) 
  }, [])

  //  ===== Methods =====
  const onChange = (key, value) => {
    onFormDataChanged(key, value)
    validateFormField(key, value, validationConfig)
  }

  return (
    <CustomCollapse
      title={`Platform settings - ${platformName}`}
      icon={FormValidators.checkFormValidity(formErrors, validationConfig) ? CheckIcon : ErrorIcon}
    >
      <CheckboxField
        name="isPrivate"
        displayName="Publish as a private application"
        onChange={(value) => onChange("isPrivate", value)}
        value={formData["isPrivate"]}
        disabled={disabled}
      />
      <SelectField
        displayName="Product Status"
        placeholder="Select product status"
        onChange={(value) => onChange("productStatus", value)}
        errorMessage={formErrors["productStatus"]?.message}
        options={allProductStatuses}
        value={formData["productStatus"]}
        disabled={disabled}
      />
      <SelectField
        displayName="Product Type"
        placeholder="Select product type"
        onChange={(value) => onChange("productType", value)}
        errorMessage={formErrors["productType"]?.message}
        options={allProductTypes}
        value={formData["productType"]}
        disabled={disabled}
      />
      <MultiSelectField
        displayName="Contract types"
        placeholder="Select contract types"
        onChange={(value) => onChange("elsaContractTypes", value)}
        errorMessage={formErrors["elsaContractTypes"]?.message}
        options={allContractTypes}
        value={formData["elsaContractTypes"]}
        disabled={disabled}
      />
    </CustomCollapse>
  )
}

export default PlatformSettingsForm
